export default "__VITE_ASSET__CvZF4cwI__";